import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../BusinessObjects/Redux/app/hook";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { RoutePath } from "../../../Utils/RoutePath";
import { useLocation, useNavigate } from "react-router-dom";
import { toggleDrawer } from "../../../BusinessObjects/Redux/features/app/appSlice";
import PasswordIcon from "@mui/icons-material/Password";
import InventoryIcon from "@mui/icons-material/Inventory";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { canCreateUser, isCubeAdmin } from "../../../Utils/EsaedroHelper";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { Typography } from "@mui/material";
import { Button } from "devextreme-react";

type Props = {};

const UserPanel = (props: Props) => {
  const profilePicUrl = "https://www.w3schools.com/howto/img_avatar2.png";
  const username = useAppSelector((state: RootState) =>
    state.user.userProfile ? state.user.userProfile.UserName : ""
  );
  const FirstName = useAppSelector((state: RootState) =>
    state.user.userProfile?.FirstName != null
      ? state.user.userProfile.FirstName
      : ""
  );
  const LastName = useAppSelector((state: RootState) =>
    state.user.userProfile?.LastName ? state.user.userProfile.LastName : ""
  );
  const drawerOpen = useAppSelector((state: RootState) => state.app.drawerOpen);
  const userProfile = useAppSelector(
    (state: RootState) => state.user.userProfile
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [fromImpersonate, setfromImpersonate] = React.useState<null | boolean>(
    null
  );
  const [visitedLocations, setVisitedLocations] = React.useState<any>([]);
  const open = Boolean(anchorEl);

  let navigate = useNavigate();
  let location = useLocation();

  useEffect(() => {
    if (visitedLocations.includes("/impersonate/")) {
      setfromImpersonate(true);
    } else if (visitedLocations.includes("/impersonate")) {
      setfromImpersonate(true);
    }
  }, [visitedLocations]);

  useEffect(() => {
    const updatedVisitedLocations = [...visitedLocations, location.pathname];
    setVisitedLocations(updatedVisitedLocations);
  }, [location.pathname]);

  let dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goTo = (path: string) => {
    handleClose();
    navigate(path);

    if (drawerOpen) dispatch(toggleDrawer());
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            marginRight: 1,
          }}
        >
          {FirstName + " " + LastName}
        </Typography>

        <Avatar
          sx={{ width: 32, height: 32 }}
          src={profilePicUrl}
          alt={username}
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={true}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => goTo(RoutePath.PROFILE)}>
          <ListItemIcon>
            <AccountCircleIcon fontSize="small" />
          </ListItemIcon>
          Profilo
        </MenuItem>
        <MenuItem onClick={() => goTo(RoutePath.CHANGE_PASSWORD)}>
          <ListItemIcon>
            <PasswordIcon fontSize="small" />
          </ListItemIcon>
          Cambia password
        </MenuItem>
        <MenuItem onClick={() => goTo(RoutePath.CHANGE_COMPANY)}>
          <ListItemIcon>
            <BusinessIcon fontSize="small" />
          </ListItemIcon>
          Cambia azienda
        </MenuItem>
        {canCreateUser(userProfile) && (
          <MenuItem onClick={() => goTo(RoutePath.CREATE_USER)}>
            <ListItemIcon>
              <GroupAddIcon fontSize="small" />
            </ListItemIcon>
            Crea utente
          </MenuItem>
        )}
        {isCubeAdmin(userProfile) ? (
          <span>
            <MenuItem onClick={() => goTo(RoutePath.CHANGE_USER_PRODUCT)}>
              <ListItemIcon>
                <InventoryIcon fontSize="small" />
              </ListItemIcon>
              Cambia prodotto
            </MenuItem>

            <Divider />

            <MenuItem onClick={() => goTo(RoutePath.DOCUMENTS_SENT)}>
              <ListItemIcon>
                <ArticleIcon fontSize="small" />
              </ListItemIcon>
              Magauto documenti inviati
            </MenuItem>

            <Divider />

            <MenuItem onClick={() => goTo(RoutePath.CREATE_FORM)}>
              <ListItemIcon>
                <DynamicFormIcon fontSize="small" />
              </ListItemIcon>
              Crea/Modifica form
            </MenuItem>

            <MenuItem onClick={() => goTo(RoutePath.RESOURCES_VIEWS)}>
              <ListItemIcon>
                <FilterAltIcon fontSize="small" />
              </ListItemIcon>
              Filtri
            </MenuItem>

            <MenuItem onClick={() => goTo(RoutePath.EDI)}>
              <ListItemIcon>
                <ArticleIcon fontSize="small" />
              </ListItemIcon>
              Edi E-Cube
            </MenuItem>
          </span>
        ) : null}
        <Divider />
        <MenuItem onClick={() => goTo(RoutePath.DOCUMENTS_PORTAL)}>
          <ListItemIcon>
            <FormatListBulletedIcon fontSize="small" />
          </ListItemIcon>
          Documentazione E-Cube
        </MenuItem>

        {!fromImpersonate ? (
          <MenuItem onClick={() => goTo(RoutePath.LOGOUT)}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};

export default UserPanel;
